<script setup lang="ts">
const props = defineProps<{
	subjects: App.Enums.ContactSubjectEnum[]
}>()

const { close } = useDialog()
const form = useForm<App.Data.Contact.CreateContactData>({
	method: 'POST',
	url: route('contact.store'),
	fields: {
		subject: props.subjects[0],
		message: '',
	},
	errorBag: 'contact',
	hooks: {
		success: () => {
			close()
		},
	},
})
</script>

<template>
	<base-dialog :title="t('views.contact.description')">
		<ui-form @submit.prevent="form.submit">
			<ui-form-item>
				<ui-label for="subject">
					{{ t('validation.attributes.subject') }}
				</ui-label>

				<ui-select v-model="form.fields.subject">
					<ui-select-trigger>
						<ui-select-value :placeholder="t('app.select_a_subject')" />
					</ui-select-trigger>
					<ui-select-content>
						<ui-select-item v-for="subject in props.subjects" :key="subject" :value="subject">
							{{ t(`app.contact_subject.${subject}`) }}
						</ui-select-item>
					</ui-select-content>
				</ui-select>
				<ui-form-error :message="form.errors.subject" />
			</ui-form-item>

			<ui-form-item>
				<ui-label for="message">
					{{ t('validation.attributes.message') }}
				</ui-label>
				<ui-textarea
					id="message"
					v-model="form.fields.message"
					required
					class="min-h-36"
				/>
				<ui-form-error :message="form.errors.message" />
			</ui-form-item>

			<ui-button type="submit" :loading="form.processing">
				{{ t('app.buttons.send') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</ui-form>
	</base-dialog>
</template>
